export const MIN_SUPPLY_HORIZON_DAYS = 1;
export const MAX_SUPPLY_HORIZON_DAYS = 365;

export function resolveSupplyPlanDefaults(defaults, canonicalDistricts) {
  const districts = Array.isArray(canonicalDistricts) ? canonicalDistricts : [];
  const savedDistricts = Array.isArray(defaults?.okrug) ? defaults.okrug : [];
  const validDistricts = districts.filter((district) => savedDistricts.includes(district));
  const horizonDays = Number(defaults?.horizon_days);

  return {
    horizonDays: Number.isInteger(horizonDays)
      && horizonDays >= MIN_SUPPLY_HORIZON_DAYS
      && horizonDays <= MAX_SUPPLY_HORIZON_DAYS
      ? horizonDays
      : null,
    okrug: validDistricts.length ? validDistricts : districts,
  };
}
